<script>
    // Раздел «Персонаж» F2 v2 — Основное / Статистика / Транспорт / Имущество / Навыки.
    // Каждая вкладка — цельная композиция, заполняющая окно контента целиком
    // (grid с растягивающимися рядами, без «кучи сверху»).
    import moment from 'moment';
    import fraction from 'json/fraction.js';
    import jobs from 'json/jobs.js';
    import vipinfo from 'json/vipinfo.js';
    import { getBusinessImage } from '../../../json/businessImages.js';
    import { format } from 'api/formatter';
    import { fly } from 'svelte/transition';
    import { cubicOut } from 'svelte/easing';

    export let selectView;
    export let selectCharData;
    export let carsList = [];

    const Bool = (t) => String(t).toLowerCase() === 'true';

    const agoText = (dateStr) => {
        const ms = Date.now() - new Date(dateStr).getTime();
        if (isNaN(ms) || ms < 0) return '—';
        const m = Math.floor(ms / 60000), h = Math.floor(m / 60), d = Math.floor(h / 24),
              mo = Math.floor(d / 30.4), y = Math.floor(d / 365);
        if (y > 0) return y + ' г. назад';
        if (mo > 0) return mo + ' мес. назад';
        if (d > 0) return d + ' д. назад';
        if (h > 0) return h + ' ч. назад';
        return m + ' мин. назад';
    };

    const dur = (mins) => {
        mins = Math.max(0, Math.floor(Number(mins) || 0));
        const d = Math.floor(mins / 1440), h = Math.floor((mins % 1440) / 60), m = mins % 60;
        let out = [];
        if (d) out.push(d + 'д');
        if (h) out.push(h + 'ч');
        out.push(m + 'м');
        return out.join(' ');
    };

    let timeTab = 0;
    $: timeValue = timeTab === 0 ? dur(selectCharData.TodayTime)
                 : timeTab === 1 ? dur(selectCharData.MonthTime)
                 : dur(selectCharData.TotalTime);

    $: lvl = Number(selectCharData.LVL) || 1;
    $: expNow = Number(selectCharData.EXP) || 0;
    $: expNext = 3 + lvl * 3;
    $: expPct = Math.max(0, Math.min(100, (expNow / expNext) * 100));
    $: warns = Number(selectCharData.Warns) || 0;
    $: hasVip = Number(selectCharData.VipLvl) > 0;

    const LICENSES = [
        ['Мотоцикл', 'M5 16.5a3 3 0 1 0 0 .01M19 16.5a3 3 0 1 0 0 .01M7.5 16.5h6L16 11l2 2M9 8l3 3M13 7.5h3L19 11'],
        ['Легковой транспорт', 'M4 16v-3l2-5h12l2 5v3M6.5 16a1.5 1.5 0 1 0 0 .01M17.5 16a1.5 1.5 0 1 0 0 .01M6 13h12'],
        ['Грузовой транспорт', 'M3 7h10v8H3zM13 10h4l3 3v2h-7M6.5 18a1.5 1.5 0 1 0 0 .01M16.5 18a1.5 1.5 0 1 0 0 .01'],
        ['Водный транспорт', 'M4 15l1.5-5h13L20 15M12 10V6M8 18c1.3 1 2.7 1 4 0s2.7-1 4 0'],
        ['Вертолёт', 'M5 6h14M12 6v4M12 10c3 0 5 1.5 5 3.5V15H7v-1.5c0-2 2-3.5 5-3.5ZM9 18h6'],
        ['Самолёт', 'M12 4v6l7 4v2l-7-2v4l2 2-2 1-2-1 2-2v-4l-7 2v-2l7-4V4z'],
        ['Оружие', 'M4 9h13l3 2-3 2h-4l-1 4h-3l1-4H4zM7 9V7'],
        ['Мед. карта', 'M5 6h14v13H5zM12 9v6M9 12h6M9 4h6v2H9z'],
        ['Парамедик', 'M12 3l7 3v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V6l7-3ZM12 8v6M9 11h6'],
    ];

    const I = {
        work: 'M4 8h16v11H4zM9 8V6a3 3 0 0 1 6 0v2',
        ring: 'M12 9a5 5 0 1 0 0 10 5 5 0 0 0 0-10ZM9 9l-2-4h10l-2 4',
        frac: 'M4 19V8l8-4 8 4v11M9 19v-5h6v5M4 19h16',
        fam: 'M8 11a2.6 2.6 0 1 0 0-5.2A2.6 2.6 0 0 0 8 11ZM16 11a2.6 2.6 0 1 0 0-5.2A2.6 2.6 0 0 0 16 11ZM3 19c0-2.5 2.2-4.4 5-4.4 1.3 0 2.6.5 3.5 1.2.9-.8 2.1-1.2 3.5-1.2 2.8 0 5 1.9 5 4.4',
        sim: 'M7 3h7l3 3v15H7zM10 17h4',
        bank: 'M4 9.5L12 4l8 5.5M5.5 10v7M10 10v7M14 10v7M18.5 10v7M3.5 19.5h17',
        crown: 'M3 17l2-9 5 4 2-7 2 7 5-4 2 9H3ZM4 20h16',
        id: 'M3 6h18v13H3zM7 13a2.2 2.2 0 1 0 0-4.4A2.2 2.2 0 0 0 7 13ZM4.5 16.5c.5-1.6 1.9-2.6 3.5-2.6s3 1 3.5 2.6M14 10h5M14 13h5M14 16h3',
        cash: 'M3 8h18v9H3zM3 11c1.7 0 3-1.3 3-3M21 11c-1.7 0-3-1.3-3-3M3 14c1.7 0 3 1.3 3 3M21 14c-1.7 0-3 1.3-3 3',
    };
</script>

<!-- ============================ ОСНОВНОЕ ============================ -->
{#if selectView === 'Osnovnoe'}
    <div class="pf os">
        <!-- левая колонка: удостоверение на всю высоту -->
        <div class="pf-id" in:fly={{ x: -14, duration: 300, easing: cubicOut }}>
            <div class="pf-id-top">
                <span class="pf-cap">Паспорт гражданина</span>
                <h2>ID {selectCharData.UUID}</h2>
                <div class="pf-tags">
                    <span class="pf-tag">{Bool(selectCharData.Gender) ? 'Мужской' : 'Женский'}</span>
                    <span class="pf-tag">20 лет</span>
                </div>
            </div>

            <div class="pf-id-rows">
                <div class="pf-row">
                    <svg viewBox="0 0 24 24"><path d={I.ring} stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <div><i>Семейное положение</i><b>{selectCharData.WeddingName || 'Нет'}</b></div>
                </div>
                <div class="pf-row">
                    <svg viewBox="0 0 24 24"><path d={I.sim} stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <div><i>Телефон</i><b>{selectCharData.Sim == -1 ? 'Нет сим-карты' : selectCharData.Sim}</b></div>
                </div>
                <div class="pf-row">
                    <svg viewBox="0 0 24 24"><path d={I.bank} stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <div><i>Номер счёта</i><b>··········{selectCharData.Bank}</b></div>
                </div>
            </div>

            <div class="pf-vip" class:none={!hasVip}>
                <svg viewBox="0 0 24 24"><path d={I.crown} stroke="currentColor" stroke-width="1.7" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <div>
                    <b>{hasVip ? vipinfo[selectCharData.VipLvl] : 'Без премиума'}</b>
                    <i>{hasVip ? 'до ' + moment(selectCharData.VipDate).format('DD.MM.YYYY') : 'доступен в магазине'}</i>
                </div>
            </div>
        </div>

        <!-- правая колонка: деньги + статусы, растянуты на всю высоту -->
        <div class="pf-os-right">
            <div class="pf-cards" in:fly={{ y: 14, duration: 300, delay: 40, easing: cubicOut }}>
                <div class="pf-money cash">
                    <div class="pf-money-top">
                        <span>Наличные</span>
                        <svg viewBox="0 0 24 24"><path d={I.cash} stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12.5" r="2.4" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>
                    </div>
                    <b>${format('money', selectCharData.Money)}</b>
                    <i>в кармане</i>
                    <div class="pf-money-wave"></div>
                </div>
                <div class="pf-money bank">
                    <div class="pf-money-top">
                        <span>Банковский счёт</span>
                        <svg viewBox="0 0 24 24"><path d={I.bank} stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                    <b>${format('money', selectCharData.BankMoney)}</b>
                    <i>счёт ····{selectCharData.Bank}</i>
                    <div class="pf-money-wave"></div>
                </div>
            </div>

            <div class="pf-grid" in:fly={{ y: 16, duration: 320, delay: 80, easing: cubicOut }}>
                <div class="pf-cell">
                    <svg viewBox="0 0 24 24"><path d={I.work} stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <i>Работа</i>
                    <b>{jobs[selectCharData.WorkID] || 'Безработный'}</b>
                </div>
                <div class="pf-cell">
                    <svg viewBox="0 0 24 24"><path d={I.frac} stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <i>Организация</i>
                    <b>{selectCharData.FractionID > 0 ? fraction[selectCharData.FractionID] : 'Нет'}</b>
                    {#if selectCharData.FractionID > 0}<em>должность {selectCharData.FractionLVL}</em>{/if}
                </div>
                <div class="pf-cell">
                    <svg viewBox="0 0 24 24"><path d={I.fam} stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <i>Семья</i>
                    <b>{selectCharData.OrganizationID > 0 ? selectCharData.OrganizationID : 'Нет'}</b>
                    {#if selectCharData.OrganizationID > 0}<em>должность {selectCharData.OrganizationLVL}</em>{/if}
                </div>
                <div class="pf-cell">
                    <svg viewBox="0 0 24 24"><path d={I.id} stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <i>Паспорт</i>
                    <b>ID {selectCharData.UUID}</b>
                </div>
            </div>
        </div>
    </div>
{/if}

<!-- ============================ СТАТИСТИКА ============================ -->
{#if selectView === 'Statiskic'}
    <div class="pf st">
        <div class="pf-statrow" in:fly={{ y: 14, duration: 280, easing: cubicOut }}>
            <div class="pf-stat lvl">
                <div class="pf-ring" style="--p:{expPct}"><b>{lvl}</b></div>
                <div class="pf-stat-info">
                    <i>Уровень</i>
                    <b>{expNow} <span>/ {expNext} респектов</span></b>
                    <div class="pf-bar"><div style="width:{expPct}%"></div></div>
                </div>
            </div>
            <div class="pf-stat">
                <div class="pf-stat-info">
                    <i>Время в игре</i>
                    <b class="big">{timeValue}</b>
                    <div class="pf-seg">
                        <button class:on={timeTab === 0} on:click={() => timeTab = 0}>День</button>
                        <button class:on={timeTab === 1} on:click={() => timeTab = 1}>Месяц</button>
                        <button class:on={timeTab === 2} on:click={() => timeTab = 2}>Всего</button>
                    </div>
                </div>
            </div>
            <div class="pf-stat" class:warn={warns > 0}>
                <div class="pf-stat-info">
                    <i>Предупреждения</i>
                    <b class="big">{warns} <span>/ 3</span></b>
                    <div class="pf-warns">
                        {#each [0, 1, 2] as i}<span class:hot={warns > i}></span>{/each}
                    </div>
                </div>
            </div>
            <div class="pf-stat">
                <div class="pf-stat-info">
                    <i>В городе</i>
                    <b class="big">{agoText(selectCharData.CreateDate)}</b>
                    <em>с {moment(selectCharData.CreateDate).format('DD.MM.YYYY')}</em>
                </div>
            </div>
        </div>

        <span class="pf-cap pad" in:fly={{ y: 14, duration: 280, delay: 60, easing: cubicOut }}>Лицензии</span>

        <div class="pf-lic" in:fly={{ y: 16, duration: 320, delay: 80, easing: cubicOut }}>
            {#each LICENSES as l, i}
                <div class="pf-liccard" class:got={Boolean(selectCharData.Licenses && selectCharData.Licenses[i])}>
                    <svg class="pic" viewBox="0 0 24 24"><path d={l[1]} stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <b>{l[0]}</b>
                    {#if Boolean(selectCharData.Licenses && selectCharData.Licenses[i])}
                        <span class="ok">
                            <svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            Получена
                        </span>
                    {:else}
                        <span class="no">
                            <svg viewBox="0 0 24 24"><rect x="6" y="10.5" width="12" height="9" rx="1.6" stroke="currentColor" stroke-width="1.7" fill="none"/><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" stroke="currentColor" stroke-width="1.7" fill="none"/></svg>
                            Нет
                        </span>
                    {/if}
                </div>
            {/each}
        </div>
    </div>
{/if}

<!-- ============================ НАВЫКИ ============================ -->
{#if selectView === 'Skills'}
    <div class="pf fill">
        {#if selectCharData.jobSkillsInfo && selectCharData.jobSkillsInfo.length}
            <div class="pf-skills">
                {#each selectCharData.jobSkillsInfo as job, idx}
                    <div class="pf-skill" in:fly={{ y: 14, duration: 260, delay: idx * 35, easing: cubicOut }}>
                        <div class="pf-skill-head">
                            <b>{job.name}</b>
                            <span class="pf-rank">{job.currentLevel} ранг</span>
                        </div>
                        <div class="pf-skill-prog">
                            <i>Прогресс</i>
                            <em>{job.current} / {job.nextLevel}</em>
                        </div>
                        <div class="pf-bar tall">
                            <div style="width:{job.currentLevel >= 5 ? 100 : (((job.currentLevel / 5) * 100) + ((job.current / job.nextLevel) * 20))}%"></div>
                        </div>
                    </div>
                {/each}
            </div>
        {:else}
            <div class="pf-empty">
                <svg viewBox="0 0 24 24"><path d="M12 3l2.4 5 5.6.7-4.1 3.8 1.1 5.5L12 15.4 7 18l1.1-5.5L4 8.7 9.6 8 12 3Z" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linejoin="round"/></svg>
                <b>Навыки пока не прокачаны</b>
                <i>Устройся на работу — прогресс появится здесь</i>
            </div>
        {/if}
    </div>
{/if}

<!-- ============================ ТРАНСПОРТ ============================ -->
{#if selectView === 'Carsuser'}
    <div class="pf fill">
        {#if carsList && carsList.length}
            <div class="pf-cars">
                {#each carsList as item, idx}
                    <div class="pf-car" in:fly={{ y: 16, duration: 260, delay: Math.min(idx, 10) * 30, easing: cubicOut }}>
                        <div class="pf-car-img">
                            <img
                                src="https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/{String(item[1] || '').toLowerCase()}.png"
                                alt="{item[1]}"
                                onerror="this.style.opacity=0" />
                        </div>
                        <b>{item[1]}</b>
                        <div class="pf-plate">{item[2]}</div>
                    </div>
                {/each}
            </div>
        {:else}
            <div class="pf-empty">
                <svg viewBox="0 0 24 24"><path d="M4 16v-3l2-5h12l2 5v3M6.5 16a1.5 1.5 0 1 0 0 .01M17.5 16a1.5 1.5 0 1 0 0 .01M6 13h12" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <b>Гараж пуст</b>
                <i>Транспорт можно купить в автосалонах города</i>
            </div>
        {/if}
    </div>
{/if}

<!-- ============================ ИМУЩЕСТВО ============================ -->
{#if selectView === 'Housebiz'}
    <div class="pf fill">
        {#if selectCharData.houseId || selectCharData.BizId || selectCharData.warehouseId}
            <div class="pf-estate">
                {#if selectCharData.houseId}
                    <div class="pf-prop" style="background-image:url(https://cdn.just-rp.online/i.imgur.com/n5Kzqd5.png)" in:fly={{ y: 16, duration: 280, easing: cubicOut }}>
                        <div class="pf-prop-in">
                            <span class="pf-cap">Недвижимость</span>
                            <h3>Дом #{selectCharData.houseId}</h3>
                            <div class="pf-prop-rows">
                                <p>Класс дома<b>{selectCharData.houseType}</b></p>
                                <p>Гаражных мест<b>{selectCharData.maxcars}</b></p>
                                <p>На счету<b>{selectCharData.houseCash}</b></p>
                                <p>Списание в час<b>{selectCharData.houseCopiesHour}</b></p>
                            </div>
                        </div>
                    </div>
                {/if}
                {#if selectCharData.BizId}
                    <div class="pf-prop" style="background-image:url({getBusinessImage(selectCharData.BizId)})" in:fly={{ y: 16, duration: 280, delay: 50, easing: cubicOut }}>
                        <div class="pf-prop-in">
                            <span class="pf-cap">Бизнес</span>
                            <h3>Бизнес #{selectCharData.BizId}</h3>
                            <div class="pf-prop-rows">
                                <p>На счету<b>{selectCharData.BizCash}</b></p>
                                <p>Списание в час<b>{selectCharData.BizCopiesHour}</b></p>
                            </div>
                        </div>
                    </div>
                {/if}
                {#if selectCharData.warehouseId}
                    <div class="pf-prop" style="background-image:url(https://cdn.just-rp.online/cdn.majestic-files.net/public/master/static/img/property/warehouses/{selectCharData.warehouseId}.jpg)" in:fly={{ y: 16, duration: 280, delay: 100, easing: cubicOut }}>
                        <div class="pf-prop-in">
                            <span class="pf-cap">Склад</span>
                            <h3>{selectCharData.warehouseName || ('Склад #' + selectCharData.warehouseId)}</h3>
                            <div class="pf-prop-rows">
                                <p>Налог до<b>{selectCharData.warehouseTaxDate}</b></p>
                            </div>
                        </div>
                    </div>
                {/if}
            </div>
        {:else}
            <div class="pf-empty">
                <svg viewBox="0 0 24 24"><path d="M4 11l8-7 8 7M6 9.5V20h12V9.5M10 20v-6h4v6" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <b>Имущества пока нет</b>
                <i>Дома и бизнесы продаются на карте города</i>
            </div>
        {/if}
    </div>
{/if}

<style>
    /* ---------- база: каждая вкладка занимает всё окно ---------- */
    .pf { height: 100%; box-sizing: border-box; color: var(--ink, #ecfff3); }
    .pf.fill { display: flex; flex-direction: column; }
    .pf-cap {
        font-size: 1.05vh; font-weight: 800; letter-spacing: 0.22em; text-transform: uppercase;
        color: rgba(220, 248, 232, 0.45);
    }
    .pf-cap.pad { margin: 1.2vh 0.2vh 0.8vh; }

    /* ================= ОСНОВНОЕ: 2 колонки на всю высоту ================= */
    .pf.os { display: grid; grid-template-columns: minmax(34vh, 36%) 1fr; gap: 1.4vh; }

    .pf-id {
        display: flex; flex-direction: column;
        padding: 2.4vh 2.2vh;
        border-radius: 1.4vh;
        border: 1px solid rgba(140, 255, 190, 0.16);
        background:
            radial-gradient(130% 120% at 0% 0%, rgba(54, 224, 124, 0.16) 0%, transparent 55%),
            rgba(10, 36, 22, 0.5);
    }
    .pf-id h2 { margin: 0.7vh 0 1.2vh; font-size: 4vh; font-weight: 900; letter-spacing: -0.01em; }
    .pf-tags { display: flex; gap: 0.6vh; flex-wrap: wrap; }
    .pf-tag {
        padding: 0.55vh 1.2vh; border-radius: 2vh; font-size: 1.2vh; font-weight: 700;
        background: rgba(54, 224, 124, 0.1); border: 1px solid rgba(140, 255, 190, 0.18);
    }

    .pf-id-rows { flex: 1; display: flex; flex-direction: column; justify-content: center; gap: 1vh; margin: 1.6vh 0; }
    .pf-row {
        display: flex; align-items: center; gap: 1.3vh;
        padding: 1.5vh 1.5vh;
        background: rgba(4, 18, 11, 0.4);
        border: 1px solid rgba(140, 255, 190, 0.1);
        border-radius: 1.1vh;
        transition: border-color 0.2s;
    }
    .pf-row:hover { border-color: rgba(140, 255, 190, 0.3); }
    .pf-row svg { width: 2.3vh; height: 2.3vh; color: #36e07c; flex: 0 0 auto; }
    .pf-row i { display: block; font-style: normal; font-size: 1.05vh; color: rgba(220, 248, 232, 0.5); }
    .pf-row b { display: block; font-size: 1.45vh; font-weight: 800; margin-top: 0.2vh; }

    .pf-vip {
        display: flex; align-items: center; gap: 1.1vh;
        padding: 1.5vh 1.7vh; border-radius: 1.2vh; color: #ffd166;
        background: linear-gradient(115deg, rgba(255, 209, 102, 0.14), rgba(255, 209, 102, 0.04));
        border: 1px solid rgba(255, 209, 102, 0.35);
        box-shadow: 0 6px 24px rgba(255, 209, 102, 0.12);
    }
    .pf-vip.none { color: rgba(220, 248, 232, 0.5); background: rgba(4, 18, 11, 0.4); border-color: rgba(140, 255, 190, 0.14); box-shadow: none; }
    .pf-vip svg { width: 2.6vh; height: 2.6vh; }
    .pf-vip b { display: block; font-size: 1.5vh; font-weight: 800; }
    .pf-vip i { font-style: normal; font-size: 1.1vh; opacity: 0.75; }

    .pf-os-right { display: grid; grid-template-rows: auto 1fr; gap: 1.4vh; min-height: 0; }

    .pf-cards { display: grid; grid-template-columns: 1fr 1fr; gap: 1.4vh; }
    .pf-money {
        position: relative; overflow: hidden;
        padding: 2vh 2.2vh 2.2vh;
        border-radius: 1.4vh;
        border: 1px solid rgba(140, 255, 190, 0.18);
        background: linear-gradient(125deg, rgba(20, 90, 48, 0.55) 0%, rgba(8, 34, 20, 0.65) 70%);
        transition: transform 0.18s, box-shadow 0.2s;
    }
    .pf-money:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(0, 0, 0, 0.35); }
    .pf-money.bank { background: linear-gradient(125deg, rgba(166, 124, 22, 0.38) 0%, rgba(8, 34, 20, 0.65) 70%); border-color: rgba(255, 209, 102, 0.22); }
    .pf-money-top { display: flex; justify-content: space-between; align-items: center; font-size: 1.15vh; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: rgba(236, 255, 243, 0.6); }
    .pf-money-top svg { width: 2.2vh; height: 2.2vh; color: rgba(236, 255, 243, 0.7); }
    .pf-money b { display: block; margin-top: 1.1vh; font-size: 3.2vh; font-weight: 900; }
    .pf-money i { font-style: normal; font-size: 1.1vh; color: rgba(236, 255, 243, 0.5); }
    .pf-money-wave {
        position: absolute; right: -6vh; bottom: -7vh; width: 18vh; height: 18vh; border-radius: 50%;
        background: radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 65%);
        pointer-events: none;
    }

    /* статусы: 2×2, растянуты на остаток высоты, контент по центру */
    .pf-grid {
        display: grid; grid-template-columns: 1fr 1fr; grid-auto-rows: 1fr;
        gap: 1.4vh; min-height: 0;
    }
    .pf-cell {
        display: flex; flex-direction: column; align-items: center; justify-content: center;
        text-align: center; gap: 0.4vh;
        padding: 1.6vh;
        background: rgba(10, 36, 22, 0.45);
        border: 1px solid rgba(140, 255, 190, 0.13);
        border-radius: 1.3vh;
        transition: border-color 0.2s, transform 0.15s;
    }
    .pf-cell:hover { border-color: rgba(140, 255, 190, 0.32); transform: translateY(-1px); }
    .pf-cell svg { width: 3.2vh; height: 3.2vh; color: #36e07c; filter: drop-shadow(0 0 8px rgba(54, 224, 124, 0.35)); margin-bottom: 0.4vh; }
    .pf-cell i { font-style: normal; font-size: 1.1vh; color: rgba(220, 248, 232, 0.5); letter-spacing: 0.1em; text-transform: uppercase; }
    .pf-cell b { font-size: 1.8vh; font-weight: 800; }
    .pf-cell em { font-style: normal; font-size: 1.15vh; color: #8df0b4; }

    /* ================= СТАТИСТИКА: ряд + лицензии на остаток ================= */
    .pf.st { display: grid; grid-template-rows: auto auto 1fr; gap: 0; min-height: 0; }
    .pf-statrow { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1.3vh; }
    .pf-stat {
        display: flex; align-items: center; gap: 1.4vh;
        padding: 2vh 1.8vh;
        background: rgba(10, 36, 22, 0.45);
        border: 1px solid rgba(140, 255, 190, 0.13);
        border-radius: 1.3vh;
        box-sizing: border-box;
        transition: border-color 0.2s;
    }
    .pf-stat:hover { border-color: rgba(140, 255, 190, 0.3); }
    .pf-stat.warn { border-color: rgba(255, 92, 92, 0.35); background: rgba(60, 14, 14, 0.3); }
    .pf-ring {
        --p: 0;
        width: 7.4vh; height: 7.4vh; border-radius: 50%; flex: 0 0 auto;
        background:
            radial-gradient(closest-side, #07271a 79%, transparent 80% 100%),
            conic-gradient(#36e07c calc(var(--p) * 1%), rgba(140, 255, 190, 0.12) 0);
        display: flex; align-items: center; justify-content: center;
        box-shadow: 0 0 22px rgba(54, 224, 124, 0.25);
    }
    .pf-ring b { font-size: 2.5vh; font-weight: 900; }
    .pf-stat-info { min-width: 0; width: 100%; }
    .pf-stat-info i { display: block; font-style: normal; font-size: 1.05vh; letter-spacing: 0.08em; text-transform: uppercase; color: rgba(220, 248, 232, 0.5); }
    .pf-stat-info b { display: block; margin-top: 0.5vh; font-size: 1.6vh; font-weight: 800; }
    .pf-stat-info b.big { font-size: 2vh; }
    .pf-stat-info b span { font-size: 1.2vh; color: rgba(220, 248, 232, 0.5); font-weight: 700; }
    .pf-stat-info em { display: block; font-style: normal; margin-top: 0.4vh; font-size: 1.1vh; color: rgba(220, 248, 232, 0.45); }
    .pf-bar { margin-top: 0.9vh; height: 0.7vh; border-radius: 1vh; overflow: hidden; background: rgba(140, 255, 190, 0.12); }
    .pf-bar.tall { height: 1vh; }
    .pf-bar div {
        height: 100%; border-radius: 1vh;
        background: linear-gradient(90deg, #14b75a, #36e07c 60%, #9ef7bc);
        box-shadow: 0 0 12px rgba(54, 224, 124, 0.55);
        position: relative;
        transition: width 0.6s cubic-bezier(0.22, 1, 0.36, 1);
    }
    .pf-bar div::after {
        content: ''; position: absolute; inset: 0;
        background: linear-gradient(110deg, transparent 30%, rgba(255, 255, 255, 0.35) 50%, transparent 70%);
        animation: pfShine 2.4s linear infinite;
    }
    @keyframes pfShine { from { transform: translateX(-100%); } to { transform: translateX(100%); } }

    .pf-seg { display: inline-flex; margin-top: 1vh; padding: 0.3vh; gap: 0.2vh; background: rgba(4, 18, 11, 0.6); border: 1px solid rgba(140, 255, 190, 0.12); border-radius: 0.9vh; }
    .pf-seg button {
        padding: 0.55vh 1.2vh; border: 0; border-radius: 0.7vh; cursor: pointer;
        background: transparent; color: rgba(220, 248, 232, 0.55);
        font-family: inherit; font-size: 1.05vh; font-weight: 700;
        transition: background 0.15s, color 0.15s;
    }
    .pf-seg button:hover { color: #ecfff3; }
    .pf-seg button.on { background: linear-gradient(110deg, #36e07c, #7df0a6); color: #04150c; font-weight: 800; }

    .pf-warns { display: flex; gap: 0.5vh; margin-top: 1.1vh; }
    .pf-warns span { flex: 1; height: 0.9vh; border-radius: 1vh; background: rgba(140, 255, 190, 0.12); }
    .pf-warns span.hot { background: linear-gradient(90deg, #ff5c5c, #ff8a80); box-shadow: 0 0 10px rgba(255, 92, 92, 0.5); }

    /* лицензии: 3×3, занимают весь остаток окна */
    .pf-lic {
        display: grid; grid-template-columns: repeat(3, 1fr); grid-auto-rows: 1fr;
        gap: 1.2vh; min-height: 0;
    }
    .pf-liccard {
        display: flex; align-items: center; gap: 1.4vh;
        padding: 0 1.8vh;
        background: rgba(10, 36, 22, 0.35);
        border: 1px solid rgba(140, 255, 190, 0.1);
        border-radius: 1.2vh;
        opacity: 0.75;
        transition: opacity 0.2s, border-color 0.2s, transform 0.15s;
    }
    .pf-liccard:hover { opacity: 1; transform: translateY(-1px); }
    .pf-liccard svg.pic { width: 3vh; height: 3vh; color: rgba(220, 248, 232, 0.55); flex: 0 0 auto; }
    .pf-liccard b { flex: 1; font-size: 1.4vh; font-weight: 700; }
    .pf-liccard span { display: inline-flex; align-items: center; gap: 0.5vh; font-size: 1.15vh; font-weight: 800; white-space: nowrap; }
    .pf-liccard span svg { width: 1.6vh; height: 1.6vh; }
    .pf-liccard span.ok { color: #36e07c; }
    .pf-liccard span.no { color: rgba(220, 248, 232, 0.4); }
    .pf-liccard.got {
        opacity: 1;
        border-color: rgba(54, 224, 124, 0.4);
        background:
            radial-gradient(140% 180% at 100% 0%, rgba(54, 224, 124, 0.14) 0%, transparent 55%),
            rgba(10, 36, 22, 0.5);
    }
    .pf-liccard.got > svg.pic { color: #36e07c; filter: drop-shadow(0 0 8px rgba(54, 224, 124, 0.4)); }

    /* ================= НАВЫКИ ================= */
    .pf-skills {
        flex: 1; display: grid; grid-template-columns: repeat(2, 1fr); grid-auto-rows: 1fr;
        gap: 1.3vh; min-height: 0;
    }
    .pf-skill {
        display: flex; flex-direction: column; justify-content: center;
        padding: 1.8vh 2vh;
        background: rgba(10, 36, 22, 0.45);
        border: 1px solid rgba(140, 255, 190, 0.13);
        border-radius: 1.3vh;
        transition: border-color 0.2s, transform 0.15s;
    }
    .pf-skill:hover { border-color: rgba(140, 255, 190, 0.3); transform: translateY(-1px); }
    .pf-skill-head { display: flex; justify-content: space-between; align-items: center; }
    .pf-skill-head b { font-size: 1.6vh; font-weight: 800; }
    .pf-rank {
        padding: 0.4vh 1.1vh; border-radius: 2vh; font-size: 1.1vh; font-weight: 800;
        color: #04150c; background: linear-gradient(110deg, #36e07c, #9ef7bc);
    }
    .pf-skill-prog { display: flex; justify-content: space-between; margin: 1.2vh 0 0.6vh; font-size: 1.15vh; }
    .pf-skill-prog i { font-style: normal; color: rgba(220, 248, 232, 0.5); }
    .pf-skill-prog em { font-style: normal; font-weight: 800; color: #8df0b4; }

    /* ================= ТРАНСПОРТ ================= */
    .pf-cars {
        flex: 1; display: grid; grid-template-columns: repeat(4, 1fr);
        grid-auto-rows: minmax(17vh, 1fr);
        gap: 1.3vh; min-height: 0; align-content: start;
    }
    .pf-car {
        display: flex; flex-direction: column; justify-content: center;
        padding: 1.4vh;
        background: rgba(10, 36, 22, 0.45);
        border: 1px solid rgba(140, 255, 190, 0.13);
        border-radius: 1.3vh;
        text-align: center;
        transition: transform 0.18s, border-color 0.2s, box-shadow 0.2s;
    }
    .pf-car:hover {
        transform: translateY(-3px);
        border-color: rgba(54, 224, 124, 0.45);
        box-shadow: 0 14px 34px rgba(0, 0, 0, 0.4), 0 0 24px rgba(54, 224, 124, 0.12);
    }
    .pf-car-img {
        flex: 1; min-height: 8vh; display: flex; align-items: center; justify-content: center;
        background: radial-gradient(60% 70% at 50% 60%, rgba(54, 224, 124, 0.1) 0%, transparent 70%);
        border-radius: 1vh;
    }
    .pf-car-img img { max-width: 92%; max-height: 100%; object-fit: contain; filter: drop-shadow(0 8px 14px rgba(0, 0, 0, 0.45)); transition: transform 0.25s; }
    .pf-car:hover .pf-car-img img { transform: scale(1.06); }
    .pf-car b { display: block; margin-top: 0.9vh; font-size: 1.35vh; font-weight: 800; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .pf-plate {
        display: inline-block; margin: 0.7vh auto 0;
        padding: 0.35vh 1.1vh;
        border-radius: 0.5vh;
        background: #ecfff3; color: #0a2416;
        font-size: 1.1vh; font-weight: 900; letter-spacing: 0.14em;
        border: 1px solid rgba(0, 0, 0, 0.3);
        box-shadow: inset 0 0 0 1px rgba(10, 36, 22, 0.25);
    }

    /* ================= ИМУЩЕСТВО ================= */
    .pf-estate {
        flex: 1; display: grid; grid-template-columns: repeat(2, 1fr); grid-auto-rows: 1fr;
        gap: 1.3vh; min-height: 0;
    }
    .pf-prop {
        position: relative; min-height: 18vh;
        border-radius: 1.4vh; overflow: hidden;
        background-size: cover; background-position: center;
        border: 1px solid rgba(140, 255, 190, 0.16);
        transition: transform 0.18s, box-shadow 0.2s;
    }
    .pf-prop:hover { transform: translateY(-2px); box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45); }
    .pf-prop-in {
        position: absolute; inset: 0;
        display: flex; flex-direction: column; justify-content: flex-end;
        padding: 2vh 2.2vh;
        background: linear-gradient(180deg, rgba(4, 18, 11, 0.1) 0%, rgba(4, 18, 11, 0.88) 78%);
    }
    .pf-prop h3 { margin: 0.4vh 0 1vh; font-size: 2.3vh; font-weight: 900; }
    .pf-prop-rows { display: grid; grid-template-columns: 1fr 1fr; gap: 0.5vh 1.8vh; }
    .pf-prop-rows p { margin: 0; display: flex; justify-content: space-between; gap: 1vh; font-size: 1.2vh; color: rgba(236, 255, 243, 0.65); }
    .pf-prop-rows p b { color: #ecfff3; font-weight: 800; }

    /* ================= ПУСТЫЕ СОСТОЯНИЯ ================= */
    .pf-empty {
        flex: 1; height: 100%;
        display: flex; flex-direction: column; align-items: center; justify-content: center;
        gap: 0.7vh; padding: 4vh 2vh;
        border: 1px dashed rgba(140, 255, 190, 0.22);
        border-radius: 1.4vh;
        background: rgba(10, 36, 22, 0.25);
        text-align: center;
        box-sizing: border-box;
    }
    .pf-empty svg { width: 5vh; height: 5vh; color: rgba(140, 255, 190, 0.4); margin-bottom: 0.6vh; }
    .pf-empty b { font-size: 1.8vh; font-weight: 800; }
    .pf-empty i { font-style: normal; font-size: 1.25vh; color: rgba(220, 248, 232, 0.5); }
</style>
